import styled from "styled-components";

export const SIN = styled.div`
position: fixed;
top: 0;
left: 0;
bottom: 0;
right: 0;
background-color: #000;
overflow-y: auto;
.form{
    padding: 20px;
    border: 1px solid #00000025;
    padding: 15px;
}
.form-wrap{
    
    display: flex;
    justify-content: center;
}
.form-head{
    display: flex;
    justify-content: center;
    margin: 25px 15px;
}
.form-head div{
    display: flex;
    justify-content: space-between;
    width: 350px;
}
.form-head div h3{
    align-self: center;
    color: indigo
}
.form-head div img{
    margin-top: 3px;
}
label{
    margin: 0px;
    font-weight: 500;
    color: #2f4f42;
}
input{
    width: 300px;
    font-weight: 500;
    color: #2f4f42;
}
.form div{
    position: relative;
    margin: 20px;
}
.alert{
    width: 300px;
}
.al-wrap{
    display: flex;
    justify-content: center;
}
.in-a{
    font-weight: 500;
}
.in-btns button{
    width: 300px;
    font-weight: 500;
}
.in-btns{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: 25px 15px;
}
.in-btns div{
    margin: 15px 5px;
}
#reset{
    position: absolute;
    top: 0px;
    right: 0px;
}
`